import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Link } from 'foundations-components/transitional/components/Link';
import { getPartnerProgramUrl } from '../utils/partnerProgramUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const PartnerProgramBanner = ({
  onLinkClick,
  onClose
}) => {
  const partnerProgramLink = getPartnerProgramUrl();
  const handleClick = () => {
    onLinkClick === null || onLinkClick === void 0 || onLinkClick();
  };
  return /*#__PURE__*/_jsx(Alert, {
    "data-selenium-id": "partner-program-banner",
    type: "info",
    closeable: true,
    onClose: onClose,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.promotions.partnerProgram.title"
    }),
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "pricingPage.promotions.partnerProgram.text",
      options: {
        partnerProgramLink: /*#__PURE__*/_jsx(Link, {
          external: true,
          href: partnerProgramLink,
          onClick: handleClick,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "pricingPage.promotions.partnerProgram.clickHere"
          })
        })
      }
    })
  });
};
export default PartnerProgramBanner;